export const fieldWrapperSx = {
  width: '100%',
};

export const fieldLabelSx = {
  display: 'block',
  mb: 1,
  color: 'var(--grey-600)',
  fontWeight: 400,
  fontSize: '0.875rem',
};

export const outlinedFieldSx = {
  m: 0,
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'var(--background-paper)',
    borderRadius: '16px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: '1px',
    borderColor: 'var(--grey-400)',
  },
  '& .MuiOutlinedInput-notchedOutline legend': {
    display: 'none',
  },
  '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'var(--grey-500)',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderWidth: '1px',
  },
  '& .MuiInputBase-input': {
    paddingTop: '12px',
    paddingBottom: '12px',
  },
};
